import { render, staticRenderFns } from "./ChannelSubscriberAdd.vue?vue&type=template&id=c7a3f116&scoped=true"
import script from "./ChannelSubscriberAdd.vue?vue&type=script&lang=ts"
export * from "./ChannelSubscriberAdd.vue?vue&type=script&lang=ts"
import style0 from "./ChannelSubscriberAdd.vue?vue&type=style&index=0&id=c7a3f116&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a3f116",
  null
  
)

export default component.exports